import type { ReactNode } from "react"
import { Popup } from "antd-mobile"

export interface PromoDialogProps {
  open: boolean
  onClose: () => void
  title?: string
  children: ReactNode
  footer?: ReactNode
}

/** 底部弹出的活动规则 / 优惠说明弹窗，基于 antd-mobile Popup */
export function PromoDialog({ open, onClose, title, children, footer }: PromoDialogProps) {
  return (
    <Popup
      visible={open}
      onMaskClick={onClose}
      position="bottom"
      bodyStyle={{
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        maxHeight: "80vh",
        overflowY: "auto",
      }}
    >
      <div className="p-4">
        {title && (
          <div className="mb-3 text-center text-lg font-bold text-ink">{title}</div>
        )}
        <div className="text-sm leading-relaxed text-ink-secondary">{children}</div>
        {footer && <div className="mt-4">{footer}</div>}
      </div>
    </Popup>
  )
}
